import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { lmsSubrouteContent } from "@/components/navigation/lmsSubRoutes";
import { RootState } from "@/components/state/store";
import {
  getEffectiveLmsMode,
  getLmsCoursesRoute,
  LMS_BILLING_PERMISSION,
  shouldBlockLmsForSubdomain,
} from "@/components/lms/lms.utils";
import { useManagerLmsAccess } from "@/context/managerLmsAccessContext";

export default function Lms() {
  const loginState = useSelector((state: RootState) => state.login);
  const location = useLocation();
  const managerLmsAccess = useManagerLmsAccess();
  const subdomain = window.location.hostname.split(".")[0];
  const effectiveMode = getEffectiveLmsMode({
    subdomain,
    permissions: loginState.permissions,
  });

  const isBillingRoute =
    location.pathname.replace(/\/$/, "") === "/kaerdemy/administrator/billing";
  const canAccessBilling =
    subdomain === "admin" &&
    loginState.permissions.includes(LMS_BILLING_PERMISSION);
  const shouldBlockRoute = isBillingRoute
    ? !canAccessBilling
    : shouldBlockLmsForSubdomain({
        subdomain,
        permissions: loginState.permissions,
      });
  const normalizedPath = location.pathname.replace(/\/$/, "");
  const isManagerMarketingRoute =
    normalizedPath === "/kaerdemy" ||
    normalizedPath === "/kaerdemy/manager/courses" ||
    /^\/kaerdemy\/manager\/courses\/[^/]+\/overview$/.test(normalizedPath);

  if (
    (subdomain === "manage" || subdomain === "portal") &&
    managerLmsAccess.isLoading
  ) {
    return null;
  }

  if (
    subdomain === "manage" &&
    managerLmsAccess.mode === "marketing" &&
    !isManagerMarketingRoute
  ) {
    return <Navigate to={getLmsCoursesRoute("manager")} replace />;
  }

  if (
    shouldBlockRoute ||
    (subdomain === "portal" && !managerLmsAccess.canAccess) ||
    (subdomain === "manage" && managerLmsAccess.mode === "denied")
  ) {
    return <Navigate to="/" replace />;
  }

  return (
    <Routes>
      <Route
        index
        element={<Navigate to={getLmsCoursesRoute(effectiveMode)} replace />}
      />
      {lmsSubrouteContent.map((content: any) => (
        <Route
          path={content.path}
          element={content.element}
          key={content.path}
        />
      ))}
    </Routes>
  );
}
